import Headroom from "headroom.js";

let _ = require('lodash');

// Headroom
const header = document.querySelector('#page-wrapper > header');

if (!_.isNil(header)) {
    const headroom = new Headroom(header);
    headroom.init();
}


// Remove no-js class from body when Javascript is activated
document.body.classList.remove('no-js');
document.body.classList.add('js')


// Track mouse movement inside header home
const cursorBall = document.querySelector('.cursor-ball');

if (document.body.classList.contains('path-frontpage')) {
    document.addEventListener('mousemove', function (e) {
        let ballOffsetLeft = 75;

        if (document.body.classList.contains('user-logged-in')) {
            ballOffsetLeft = 155;
        }

        cursorBall.setAttribute("style", "top: " + (e.pageY - 100) + "px; left: " + (e.pageX - ballOffsetLeft) + "px;")
    });

    let headerHomeButtons = document.querySelectorAll('.node--type-homepage .section-header a');

    if (!_.isEmpty(headerHomeButtons)) {
        Array.from(headerHomeButtons).forEach(headerHomeButton => {
            headerHomeButton.addEventListener('mouseenter', function () {
                cursorBall.classList.add('enlarge');
            });

            headerHomeButton.addEventListener('mouseleave', function () {
                cursorBall.classList.remove('enlarge');
            });
        });
    }
}

// Search bar opens on click. Button is deactivated when value is empty.
const searchBar = document.querySelector('header #block-zichtbaarformuliersearchpage-1 #views-exposed-form-search-page-1');

if (!_.isNil(searchBar)) {
    const searchBarButton = searchBar.querySelector('button.form-submit');

    searchBarButton.addEventListener('click', (e) => {
        if (!searchBar.classList.contains('open')) {
            searchBar.querySelector('input').value = '';
        }

        if (searchBar.querySelector('input').value === '') {
            searchBar.classList.toggle('open');
            e.preventDefault();
        }
    });
}

// FAQ items active class
const viewFaqLinks = document.querySelectorAll('.view-faq-categories .views-row a.faq-filter');

if (!_.isEmpty(viewFaqLinks)) {
    Array.from(viewFaqLinks).forEach(link => {
        link.addEventListener('click', (e) => {
            Array.from(viewFaqLinks).forEach(faqFilter => faqFilter.classList.remove('active'));

            link.classList.add('active');
        });
    });
}

// Make whole card clickable
function clickableCard() {
    let link = this.getElementsByTagName('A')[0];

    if (link.hasAttribute('type')) {
        window.open(link, '_blank');
    } else {
        window.open(link, '_self');
    }
}

// Whole teaser clickable
let teasers = document.getElementsByClassName('teaser');

if (!_.isEmpty(teasers)) {
    Array.from(teasers).forEach(teaser => {
        let link = teaser.getElementsByTagName('A')[0];

        if (!_.isNil(link)) {
            teaser.addEventListener('click', clickableCard, false);
            teaser.style.cursor = 'pointer';
        }
    });
}


// Check if input has value, if so add class
const inputFields = document.querySelectorAll('form input');

if (!_.isEmpty(inputFields)) {
    Array.from(inputFields).forEach(inputField => {
        if (inputField.value !== '') {
            inputField.classList.add('filled');
        }

        inputField.addEventListener('blur', (e) => {
            if (inputField.value === '') {
                inputField.classList.remove('filled');

                return;
            }

            inputField.classList.add('filled');
        });
    });
}

const checkFormInput = (form, fileFieldClass, fileFieldName) => {
    if (!form) {
        return
    }

    let formSubmitButton = form.querySelector('button.webform-button--submit');
    formSubmitButton.disabled = false;


    let fileUpload = form.querySelector(`.${fileFieldClass} input.form-file`)

    if (fileUpload) {
        fileUpload.addEventListener('change', (event) => {
            formSubmitButton.disabled = true;
        })
    }

    let fileUploadRemoveButton = form.querySelector(`.${fileFieldClass} button[name="${fileFieldName}_remove_button"]`)

    if (fileUploadRemoveButton) {
        fileUploadRemoveButton.addEventListener('click', (event) => {
            formSubmitButton.disabled = true;
        })
    }
}

let form = document.querySelector('form.webform-submission-sollicitatieformu-form');
checkFormInput(form, 'form-item-upload-cv','upload_cv')

Drupal.behaviors.vacancyForm = {
    attach: function (context, settings) {
        if (context.classList && context.classList.contains('webform-submission-sollicitatieformu-form')) {
            let form = document.querySelector('form.webform-submission-sollicitatieformu-form');
            checkFormInput(form, 'form-item-upload-cv', 'upload_cv')
        }
    }
};

const categoryButtons = document.querySelectorAll('.section-knowledgebase-nav a');

if (!_.isEmpty(categoryButtons)) {
    let currentUrl = window.drupalSettings.ef2_custom?.page_category_url ?? window.location.pathname;

    Array.from(categoryButtons).forEach(categoryButton => {
        let categoryUrl = categoryButton.getAttribute('href');

        if (categoryUrl !== currentUrl) {
            return;
        }

        categoryButton.classList.add('active');
    });
}